<!-- Default layout used across the application. Contains navigation drawer, app bar and content -->
<template>
  <v-app>

    <!-- Application bar - the top bar -->
      <v-app-bar app clipped-left color="primary" class="white--text">
        <!-- Navigation drawer toggle -->
         <template v-slot:prepend>
          <v-app-bar-nav-icon class="white--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        </template>
        <v-app-bar-title id="applicationTitle">
          {{ $t("title") }}
        </v-app-bar-title>
          <v-spacer />
        <!-- Environment badge to display current environment if not on prod -->
        <EnvironmentBadge v-if="env !== 'prod' && env !== 'production'" />
        
        <a href="https://anketa-test.is.cvut.cz/wiki/doku.php/doc-navody-admini" target="_blank">
          <v-btn icon>
            <v-icon  style="color: white;" size="32">mdi-help-circle</v-icon>
          </v-btn>
        </a>
      </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped>
      <!-- Sidenav component containing the menu -->
      <Sidenav />
      <template v-slot:append>

        <v-list-item link nuxt exact to="/errors"
          prepend-icon="mdi-alert-circle">

          <v-list-item-title>Chyby</v-list-item-title>
 
        </v-list-item>
        <!-- Not yet implemented dark mode switcher -->
        <!--        <v-list-item>-->
        <!--          <v-switch-->
        <!--            v-model="$vuetify.theme.dark"-->
        <!--            hide-details-->
        <!--            label="Tmavý režim"-->
        <!--            class="mr-3"-->
        <!--            color="white"-->
        <!--          />-->
        <!--        </v-list-item>-->
        <!-- Help dialog -->
        <v-dialog v-model="help" width="800px">
          <template v-slot:activator>
            <v-list-item prepend-icon="mdi-lifebuoy" @click="help = true">
              <v-list-item-title>Hlášení chyb</v-list-item-title>
            </v-list-item>
          </template>
          <v-card>
            <v-card-title class="headline mb-2"> Hlášení chyb </v-card-title>
            <v-card-text>
              <v-text-field
                outlined
                disabled
                :value="$route.path"
              ></v-text-field>
              <v-textarea
                outlined
                label="Popis"
                placeholder="Zde, prosím, popište chybu v aplikaci."
                v-model="feedback"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeModal"> Zrušit </v-btn>
              <v-btn text @click="sendFeedback"> Odeslat </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <div v-if="showSnackbar">
          <Snackbar 
          :propMessage="toastMessage" 
          :propColor="toastColor" 
          :propShow="showSnackbar" 
          @close="closeToast" />
        </div> -->
        <div v-if="useSnackbarStore().show">
          <Snackbar 
          :propMessage="useSnackbarStore().message" 
          :propColor="useSnackbarStore().color" 
          :propShow="useSnackbarStore().show"/>
        </div>

      </template>
    </v-navigation-drawer>



    <!-- Content of the page - nuxt's router -->
    <!-- Bottom padding to compensate for the FAB button on most of the pages -->
    <v-main style="padding-bottom: 50px">
      <div>
        <slot />
      </div>

    </v-main>
  </v-app>
</template>

<script setup>
/** Used for translation */
const { t } = useI18n()
</script>

<script>
/**
 * @description Default layout used across the application. Contains navigation drawer, app bar and content
 * @module layouts/default
 * @see components/EnvironmentBadge
 * @see components/Sidenav
 * @vue-data {String} feedback - Feedback text
 * @vue-data {boolean} drawer - If drawer is open
 * @vue-data {boolean} help - If help modal is open
 * @vue-data {String} env - Shows badge informing about dev / stg version
 * @vue-methods closeModal - Close the help modal
 * @vue-methods sendFeedback - Send feedback to the backend
 */

import EnvironmentBadge from '../components/EnvironmentBadge'
import Sidenav from '../components/Sidenav'
import Snackbar from '../components/Snackbar.vue';
import {useUserStore} from '../store/user'
import {useSnackbarStore} from '../store/snackbar'
import { useRuntimeConfig } from 'nuxt/app';


export default {
  /**
   * Components used in the layout
   */
  components: {
    EnvironmentBadge,
    Sidenav,
  },
  data() {
    return {
      /** Feedback text */
      feedback: "",
      /** If drawer is open */
      drawer: true, 
      /** If help modal is open */
      help: false,
      env: useRuntimeConfig().public.ENV, // Shows badge informing about dev / stg version
    };
  },

  head() {
    /** Page title template */
    return {
      titleTemplate: `%s | ${this.$t('default.title')}`,
    };
  },
  methods: {

    /**
     * Close the help modal
     */
    closeModal() {
      this.help = false
      this.feedback = ""
    },
    
    /**
     * Send feedback to the backend
     */
    async sendFeedback() {
      await fetch(useRuntimeConfig().public.apiBase + "/report",{
          method: 'POST',
          headers: {
      			"Content-Type": "application/json",
      			"Authorization": "Bearer " + useUserStore().token
      		},
          body: JSON.stringify({
            path: this.$route.path,
            text: this.feedback,
          })
        })
        .then(() => {
          useSnackbarStore().showSnackbar(`Chyba byla úspěšně nahlášena!`, 'success');
          this.closeModal();
        }).catch(() => {
          useSnackbarStore().showSnackbar(`Něco se pokazilo!`, 'error');
        });
    },
  },
};
</script>
